import { render } from "./WarenkorbItem.vue?vue&type=template&id=208ba0f2&scoped=true"
import script from "./WarenkorbItem.vue?vue&type=script&lang=js"
export * from "./WarenkorbItem.vue?vue&type=script&lang=js"

import "./WarenkorbItem.vue?vue&type=style&index=0&id=208ba0f2&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208ba0f2"]])

export default __exports__